import AudioPlayer from "./AudioPlayerWeb";
export {
  AudioPlayer as AudioPlayerSmall,
  AudioPlayer as AudioPlayerLarge
};
